import React from "react";
import { BigGradientText, CenterText } from '../Styles/Styles';
import Navigation from "../components/Navigation";

const Services = () => {
  return (
  <>
    <Navigation />
    <CenterText>
      <BigGradientText>Services</BigGradientText>
    </CenterText>
    </>
  );
};

export default Services;